/* eslint-disable @typescript-eslint/naming-convention */

const categoryMappingHHS_V07: Record<string, string> = {
  8: 'Cancer',
  9: 'Cancer',
  10: 'Cancer',
  11: 'Cancer',
  12: 'Cancer',
  13: 'Cancer',
  18: 'Diabetes',
  20: 'Diabetes',
  21: 'Diabetes',
  22: 'Diabetes',
  23: 'Protein-Calorie Malnutrition',
  26: 'Mucopolysaccharidosis',
  27: 'Lipidoses and Glycogenosis',
  28: 'Congenital Metabolic Disorders, Not Elsewhere Classified',
  29: 'Amyloidosis, Porphyria, and Other Metabolic Disorders',
  30: 'Adrenal, Pituitary, and Other Significant Endocrine Disorders',
  34: 'Liver Disease',
  '35.2': 'Liver Disease',
  36: 'Liver Disease',
  '37.1': 'Liver Disease',
  '37.2': 'Liver Disease',
  41: 'Intestine Transplant Status/Complications',
  46: 'Chronic Pancreatitis',
  48: 'Inflammatory Bowel Disease',
  56: 'Autoimmune Disorders',
  57: 'Autoimmune Disorders',
  61: 'Osteogenesis Imperfecta and Other Osteodystrophies',
  62: 'Congenital/Developmental Skeletal and Connective Tissue Disorders',
  63: 'Cleft Lip/Cleft Palate',
  64: 'Major Congenital Anomalies of Diaphragm, Abdominal Wall, and Esophagus, Age < 2',
  66: 'Hemophilia',
  67: 'Myelodysplastic Syndromes and Myelofibrosis',
  68: 'Aplastic Anemia',
  69: 'Acquired Hemolytic Anemia, Including Hemolytic Disease of Newborn',
  70: 'Sickle Cell Disease',
  71: 'Sickle Cell Disease',
  73: 'Immunodeficiencies',
  74: 'Immunodeficiencies',
  75: 'Coagulation Defects and Other Specified Hematological Disorders',
  81: 'Substance Use Disorder',
  82: 'Substance Use Disorder',
  83: 'Substance Use Disorder',
  84: 'Substance Use Disorder',
  '87.1': 'Behavioral Health',
  '87.2': 'Behavioral Health',
  88: 'Behavioral Health',
  90: 'Behavioral Health',
  94: 'Anorexia/Bulimia Nervosa',
  96: 'Congenital Anomalies',
  97: 'Congenital Anomalies',
  102: 'Developmental Disorders',
  103: 'Developmental Disorders',
  107: 'Paralyses',
  109: 'Paralyses',
  110: 'Paralyses',
  111: 'Amyotrophic Lateral Sclerosis and Other Anterior Horn Cell Disease',
  112: 'Cerebral Palsy',
  113: 'Cerebral Palsy',
  114: 'Spina Bifida and Other Brain/Spinal/Nervous System Congenital Anomalies',
  115: 'Myasthenia Gravis/Myoneural Disorders and Guillain-Barre Syndrome/Inflammatory and Toxic Neuropathy',
  117: 'Muscular Dystrophy',
  118: 'Multiple Sclerosis',
  119: 'Parkinson\'s, Huntington\'s, and Spinocerebellar Disease, and Other Neurodegenerative Disorders',
  120: 'Seizure Disorders and Convulsions',
  121: 'Hydrocephalus',
  122: 'Coma, Brain Compression/Anoxic Damage',
  123: 'Narcolepsy and Cataplexy',
  125: 'Respiratory Failure',
  127: 'Respiratory Failure',
  128: 'Heart Disease',
  129: 'Heart Disease',
  130: 'Heart Disease',
  135: 'Heart Infection/Inflammation, Except Rheumatic',
  137: 'Heart Defects',
  138: 'Heart Defects',
  139: 'Heart Defects',
  142: 'Specified Heart Arrhythmias',
  149: 'Cerebral Aneurysm and Arteriovenous Malformation',
  150: 'Paralyses',
  151: 'Paralyses',
  153:	'Atherosclerosis of the Extremities with Ulceration or Gangrene',
  154:	'Vascular Disease with Complications',
  156:	'Pulmonary Embolism and Deep Vein Thrombosis',
  158: 'Lung Disease',
  159: 'Lung Disease',
  160: 'Lung Disease',
  '161.1': 'Lung Disease',
  '161.2': 'Lung Disease',
  162:	'Fibrosis of Lung and Other Lung Disorders',
  174:	'Exudative Macular Degeneration',
  183: 'Kidney Disease',
  184: 'Kidney Disease',
  187: 'Kidney Disease',
  188: 'Kidney Disease',
  217:	'Chronic Ulcer of Skin, Except Pressure',
  219:	'Major Skin Burn or Condition',
  234: 'Amputations',
  242: 'Newborns',
  243: 'Newborns',
  244: 'Newborns',
  245: 'Newborns',
  246: 'Newborns',
  247: 'Newborns',
  248: 'Newborns',
  251:	'Stem Cell, Including Bone Marrow, Transplant Status/Complications',
  253:	'Artificial Openings for Feeding or Elimination',
  254: 'Amputations'
}
export default categoryMappingHHS_V07
